import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
export default function LeftMenu() {
  const location = useLocation();
  const isActive = (path) => location.pathname.endsWith(path);

  const handleMenuClick = (e) => {
    // Only close if we clicked a link or inside a link
    if (e.target.closest("a")) {
      if (window.innerWidth < 1200) {
        const body = document.body;
        const className = "g-sidenav-pinned";
        if (body.classList.contains(className)) {
          const toggler = document.getElementById("iconNavbarSidenav");
          if (toggler) {
            toggler.click();
          } else {
            body.classList.remove(className);
            const sidenav = document.getElementById("sidenav-main");
            if (sidenav) {
              sidenav.classList.remove("bg-white");
            }
          }
        }
      }
    }
  };

  return (
    <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2 bg-white my-2" id="sidenav-main">
      <div className="sidenav-header">
        <i className="fas fa-times p-3 cursor-pointer text-dark opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
        <Link className="navbar-brand px-4 py-3 m-0" to="/cpnl/dashboard" onClick={handleMenuClick}>
          <img src="https://mahavedika.com/images/MV-LOGO-Lg.png" className="navbar-brand-img" alt="main_logo" />
        </Link>
      </div>
      <hr className="horizontal dark mt-0 mb-2" />
      <div className="collapse navbar-collapse w-auto" id="sidenav-collapse-main" onClick={handleMenuClick}>
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link className={`nav-link ${isActive('dashboard') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/dashboard">
              <i className="material-symbols-rounded opacity-5">dashboard</i>
              <span className="nav-link-text ms-1">Dashboard</span>
            </Link>
          </li>
          <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-dark font-weight-bolder opacity-5">Masters</h6>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('branch') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/branch">
              <i className="material-symbols-rounded opacity-5">domain</i>
              <span className="nav-link-text ms-1">Branches</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('expenditure-type') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/expenditure-type">
              <i className="material-symbols-rounded opacity-5">payments</i>
              <span className="nav-link-text ms-1">Expenditure Types</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('role') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/role">
              <i className="material-symbols-rounded opacity-5">admin_panel_settings</i>
              <span className="nav-link-text ms-1">Roles</span>
            </Link>
          </li>
          <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-dark font-weight-bolder opacity-5">Partner Management</h6>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('vendor') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/vendor">
              <i className="material-symbols-rounded opacity-5">storefront</i>
              <span className="nav-link-text ms-1">Vendors</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('client') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/client">
              <i className="material-symbols-rounded opacity-5">person</i>
              <span className="nav-link-text ms-1">Clients</span>
            </Link>
          </li>
          <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-dark font-weight-bolder opacity-5">Team</h6>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('member') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/member">
              <i className="material-symbols-rounded opacity-5">groups</i>
              <span className="nav-link-text ms-1">Members</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('staff') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/staff">
              <i className="material-symbols-rounded opacity-5">badge</i>
              <span className="nav-link-text ms-1">Staff</span>
            </Link>
          </li>
          <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-dark font-weight-bolder opacity-5">Project Management</h6>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('project') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/project">
              <i className="material-symbols-rounded opacity-5">assignment</i>
              <span className="nav-link-text ms-1">Projects</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('project-estimates') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/project-estimates">
              <i className="material-symbols-rounded opacity-5">calculate</i>
              <span className="nav-link-text ms-1">Project Estimates</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('project-schedule') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/project-schedule">
              <i className="material-symbols-rounded opacity-5">schedule</i>
              <span className="nav-link-text ms-1">Project Schedule</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('project-team') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/project-team">
              <i className="material-symbols-rounded opacity-5">group_add</i>
              <span className="nav-link-text ms-1">Project Team</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('project-team-schedule') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/project-team-schedule">
              <i className="material-symbols-rounded opacity-5">event_available</i>
              <span className="nav-link-text ms-1">Team Schedule</span>
            </Link>
          </li>
          <li className="nav-item mt-3">
            <h6 className="ps-4 ms-2 text-uppercase text-xs text-dark font-weight-bolder opacity-5">Transactions</h6>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('pay-in') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/pay-in">
              <i className="material-symbols-rounded opacity-5">account_balance_wallet</i>
              <span className="nav-link-text ms-1">Pay-in</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('pay-out') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/pay-out">
              <i className="material-symbols-rounded opacity-5">paid</i>
              <span className="nav-link-text ms-1">Pay-out</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('petty-cash') ? 'active bg-gradient-dark text-white' : 'text-dark'}`} to="/cpnl/petty-cash">
              <i className="material-symbols-rounded opacity-5">receipt_long</i>
              <span className="nav-link-text ms-1">Petty Cash</span>
            </Link>
          </li>

        </ul>
      </div>
    </aside>
  );
}
